// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3-EBJ","bigColWidth":"Table_bigColWidth__2iN9G","biggerColWidth":"Table_biggerColWidth__3d8SQ","row":"Table_row__D7H62","col":"Table_col__2NFwx"};